
// Quiz App React Base Styles
import colors from "assets/theme-dark/base/colors";

const { transparent, light } = colors;

const iconButton = {
  styleOverrides: {
    root: {
      color:light.main,
    },
  },
};

export default iconButton;
